import { Component, OnInit, Input } from '@angular/core';
import { FileService } from '../../services/file/file.service';
import { DisplayService } from '../../services/display/display.service';

@Component({
	selector: 'pcm-file-list',
	templateUrl: './file-list.component.html',
	styleUrls: ['./file-list.component.scss']
})
export class FileListComponent implements OnInit {

	@Input() files = [];
	@Input() canDelete = true;

	constructor(
		public displayService: DisplayService,
		private fileService: FileService
	) { }

	ngOnInit() {
	}

	openFile(file) {
		this.fileService.openFile(file.id, file.name);
	}

	deleteFile(file) {
		this.fileService.deleteFile(file.id);
	}
}
